// @flow
import { getConsumerPropertiesList, producersList, templates } from '~/core/utils/recipes';
import { getNameForProduct, getProductItems, getTypeForProduct } from '../products/selectors';

import { createSelector } from 'reselect';
import { fromJS } from 'immutable';
import { identity } from 'lodash/fp';

export const getRecipesSection = (state: { recipes: typeof fromJS }) => state.recipes;
const getTemplateNameFromProps = (_, props) => (props && props.name) || '';
const getProducerIdFromProps = (_, { producerId }) => producerId;
const getConsumerIdFromProps = (_, { consumerId }) => consumerId;

export const getRecipesList = createSelector(
    [identity, getRecipesSection, getProducerIdFromProps, getConsumerIdFromProps],
    (state, recipes, producerId, consumerId) =>
        recipes.get('recipes').filter(
            r =>
                (!producerId || r.getIn(['data', 'producer']) === producerId) &&
                (!consumerId || r.getIn(['data', 'consumer']) === consumerId) &&
                producersList.includes(
                    getTypeForProduct(state, {
                        id: r.getIn(['data', 'producer'])
                    })
                ) &&
                (!r.getIn(['data', 'consumer']) ||
                    getConsumerPropertiesList(
                        getTypeForProduct(state, {
                            id: r.getIn(['data', 'consumer'])
                        })
                    ).length > 0)
        )
);

export const getTemplatesList = createSelector(
    [getRecipesSection, getProducerIdFromProps, getConsumerIdFromProps],
    (recipes, producerId, consumerId) =>
        recipes
            .get('templates')
            .filter(
                t =>
                    Object.keys(templates).includes(t.get('name')) &&
                    (!producerId ||
                        t
                            .get('producers')
                            .map(p => p.get('id'))
                            .includes(producerId)) &&
                    (!consumerId ||
                        t
                            .get('producers')
                            .map(p => p.get('consumers'))
                            .flatten()
                            .includes(consumerId))
            )
            .map(t => t.get('name'))
);

export const makeGetTemplate = () =>
    createSelector([getRecipesSection, getTemplateNameFromProps], (recipes, name) =>
        recipes.get('templates').find(t => t.get('name') === name)
    );

export const makeGetProducersList = () =>
    createSelector([identity, makeGetTemplate()], (state, template) =>
        template.get('producers').map(p => {
            const id = p.get('id');
            return fromJS({ id, name: getNameForProduct(state, { id }) });
        })
    );

export const getCurrentRecipe = createSelector(getRecipesSection, recipes => recipes.get('currentRecipe'));

export const makeGetConsumersList = () =>
    createSelector(
        [identity, makeGetTemplate(), getCurrentRecipe],
        (state, template, currentRecipe) =>
            currentRecipe.getIn(['data', 'producer']) === -1
                ? fromJS([])
                : template
                      .get('producers')
                      .find(p => p.get('id') === currentRecipe.getIn(['data', 'producer']))
                      .get('consumers')
                      .map(id =>
                          fromJS({
                              id,
                              name: getNameForProduct(state, { id })
                          })
                      )
    );

export const getIsFirstLoadingDone = createSelector(getRecipesSection, recipes => recipes.get('isFirstLoadingDone'));

export const getModalVisiblePage = createSelector(getRecipesSection, recipes => recipes.get('modalVisiblePage'));

export const hasRecipeProducts = createSelector(getProductItems, products =>
    products.some(p => producersList.includes(p.get('type')))
);

export const getHasActiveHeatingRecipes = createSelector([getRecipesSection, getProductItems], (recipes, products) => {
    const listOfHeatingProducts = products.filter(p => p.get('type') === 'heating').map(p => p.get('id'));
    return recipes.get('recipes').some(r => {
        return r.getIn(['data', 'enabled']) && listOfHeatingProducts.includes(r.getIn(['data', 'consumer']));
    });
});



// WEBPACK FOOTER //
// ./src/core/state/recipes/selectors.js